import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class WalletHelperService {
  /**
   * Coonstructor
   * @param api
   */
  constructor(private api: ApiService) {}

  /**
   * Fiolter asset
   * @param asset_id
   * @returns
   */
  public filterAssets(asset_id: number) {
    if (this.api.assets.length > 0) {
      for (var i = 0; i < this.api.assets.length; i++) {
        if (this.api.assets[i].asset_id == asset_id) {
          return this.api.assets[i];
          break;
        }
      }
      return null;
    } else {
      return null;
    }
  }

  async bootHomePage() {
    this.api.getAssetsList().then(
      (result: any) => {
        if (!result.error) {
          this.api.assets = result.data.assets;
          this.syncWalletBalances(null, null);
          this.searchAssets();
          this.loadWallets();
          this.api.assets_loaded = true;
        }
      },
      (error: any) => {
        console.log("error");
      }
    );
  }

  async loadWallets() {
    this.api.getWalletList().then(
      (result: any) => {
        if (!result.error) {
          this.api.wallets = result.data.wallets;
        }
      },
      (error: any) => {
        console.log("error");
      }
    );
  }

  searchAssets(searchText: string = "") {
    if (searchText !== "") {
      this.api.searchedAssets = this.api.assets.filter((o) => {
        return (
          (o.name.toLowerCase().includes(searchText) ||
            o.symbol.toLowerCase().includes(searchText)) &&
          o.is_visible == 1
        );
      });
    } else {
      this.api.searchedAssets = this.api.assets.filter((o) => {
        return o.is_visible == 1;
      });
    }
  }

  /**
   * Filter wallets by blockchain id
   * @param blockchain_id
   * @returns
   */
  public filterWallets(blockchain_id: number) {
    let filteredWallets = [];
    for (var i = 0; i < this.api.wallets.length; i++) {
      if (this.api.wallets[i].blockchain_id == blockchain_id) {
        filteredWallets.push(this.api.wallets[i]);
      }
    }
    return filteredWallets;
  }

  /**
   * Filter Affiliate Wallets
   * @returns
   */
  public filterAffiliateWallets() {
    let filteredWallets = [];
    for (var i = 0; i < this.api.wallets.length; i++) {
      if (this.api.wallets[i].is_affiliate == 1) {
        filteredWallets.push(this.api.wallets[i]);
      }
    }
    return filteredWallets;
  }

  /**
   * Filter wallet by Wallet ID
   * @param wallet_id
   * @returns
   */
  public filterWalletByWalletId(wallet_id: number) {
    for (var i = 0; i < this.api.wallets.length; i++) {
      if (this.api.wallets[i].wallet_id == wallet_id) {
        return this.api.wallets[i];
      }
    }
    return null;
  }

  /**
   * Get Balance By Asset
   * @param asset_id
   */
  private getBalanceByAsset(asset_id: number) {
    let balance = 0;
    for (let i = 0; i < this.api.balances.length; i++) {
      if (this.api.balances[i].asset_id == asset_id) {
        balance += this.api.balances[i].balance;
      }
    }
    return balance;
  }

  /**
   * Filter asset balances
   */
  public filterAssetBalances() {
    for (let i = 0; i < this.api.assets.length; i++) {
      this.api.assets[i].balance = this.getBalanceByAsset(
        this.api.assets[i].asset_id
      );
    }

    this.getTotalAssets();
  }

  /**
   * Get Portfolio Balance
   * @returns
   */
  public getPortfolioBalance() {
    let balance = 0;
    for (let i = 0; i < this.api.assets.length; i++) {
      balance += this.api.assets[i].balance * this.api.assets[i].price;
    }
    return balance;
  }

  /**
   * Get Total assets of user
   * @returns
   */
  public getTotalAssets() {
    this.api.totalAssetsCount = this.api.assets.filter((o) => {
      return o.balance > 0;
    }).length;
  }

  /**
   * Sync wallet balances
   * @param wallet_id
   * @param asset_id
   */
  public syncWalletBalances(wallet_id: number, asset_id: number) {
    if (wallet_id == null || asset_id == null) {
      this.api.getBalances().then(
        (result: any) => {
          if (!result.error) {
            this.api.balances = result.data.balances;
            this.filterAssetBalances();
            this.api.portfolioBalance = this.getPortfolioBalance();

            for (let i = 0; i < this.api.balances.length; i++) {
              this.api.filteredBalances[
                this.api.balances[i].asset_id +
                  "_" +
                  this.api.balances[i].wallet_id
              ] = this.api.balances[i].balance;
            }
          }
        },
        (error: any) => {
          console.log("error");
        }
      );
    } else {
      this.api.getWalletBalance(wallet_id, asset_id).then(
        (result: any) => {
          if (!result.error) {
            this.api.balances = result.data.balances;
            this.filterAssetBalances();
            this.api.portfolioBalance = this.getPortfolioBalance();
            for (let i = 0; i < this.api.balances.length; i++) {
              this.api.filteredBalances[
                this.api.balances[i].asset_id +
                  "_" +
                  this.api.balances[i].wallet_id
              ] = this.api.balances[i].balance;
            }
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }
}
